import React from 'react';
import { Button, ButtonAsButtonProps } from '../../../buttons';

export type ModalCancelButtonProps = ButtonAsButtonProps;

export const ModalCancelButton: React.FC<ModalCancelButtonProps> = ({
  ...rest
}) => {
  return (
    <Button
      className="w-full sm:w-auto"
      layout="squared"
      variant="white"
      font="boldGray"
      {...rest}
    />
  );
};
